import { Col as _Col, ColProps as _ColProps } from "reactstrap";

    export const Col = _Col;
    export type ColProps = _ColProps;
    